import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function MoveTicketHeader() {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.moveToSupportCard.header"
  });
}